const style = () => ({
    display: 'flex'
})

export default style
